import { useSectionEventOnViewportEntrance } from '@/hooks/useSectionEventOnViewportEntrance';
import React from 'react';
import styled from 'styled-components';
import { type Coverage, CoverageSection } from './Coverage';

export interface BasicCoveragesProps {
  title: string;
  subtitle: string;
  coverages: Coverage[];
  darkBackground: boolean;
}

const StyledCoverageSection = styled(CoverageSection)`
  z-index: 1;
`;

const BasicCoverages: React.FC<BasicCoveragesProps> = props => {
  const intersectionRef = useSectionEventOnViewportEntrance({
    sectionName: 'basicCoverages',
    page: 'car',
  });

  return <StyledCoverageSection ref={intersectionRef} {...props} itemWidth={[220, 248, 220]} itemMargin={[20, 50]} />;
};

export default React.memo(BasicCoverages);
